import './GiglistBanner.scss'

import { Subcategory } from '../../../../Models/SubCategory'

interface GigListBannerPropsInterface {
  subcategory: Subcategory | undefined
}

const GiglistBanner = ({subcategory}: GigListBannerPropsInterface) => {

  return (
    <section className='gigPageBanner'>
      <div className="bannerImageWrapper">
        <img src={subcategory?.headerImageUrl} alt="banner" />
        <div className="bannerImageScreen">
          <div className="bannerImageContent">
            <h1>{ subcategory && subcategory.name }</h1>
            <p>{ subcategory && subcategory.tagline }</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GiglistBanner